// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3sLT0","ranges":"BmiRanges_ranges__1qjlP"};